export default __webpack_public_path__ + "static/media/csc-radio.01a36a9e.svg";